import {cloneDeep, get, includes, map, set} from 'lodash';

const preferencesConfig = {
    formData: {
        whitelist: [
            'audits',
            'bestMatches',
            'displayPaths',
            'displayPathModifiers',
            'mediaItems',
            'mediaItemsEnhanced',
            'mediaItemsMapped',
            'moviesAndPrograms',
            'moviesAndProgramsEpisodes',
            'moviesAndProgramsMappingEpisodes',
            'moviesAndProgramsMappingFranchise',
            'moviesAndProgramsRelated',
            'networks',
            'providers',
            'rules',
            'unmappedMediaItems',
            'users',
            'violations',
        ],
        authReset: [
            'bestMatches',
            'unmappedMediaItems',
            'moviesAndProgramsMappingEpisodes',
            'moviesAndProgramsMappingFranchise',
        ],
        paths: ['operators', 'values', 'visibleFields'],
    },
    layout: true,
    servicesSearchData: {
        whitelist: [
            'audits',
            'displayPaths',
            'displayPathModifiers',
            'mediaItems',
            'mediaItemsEnhanced',
            'mediaItemsMapped',
            'moviesAndPrograms',
            'moviesAndProgramsEpisodes',
            'moviesAndProgramsMappingEpisodes',
            'moviesAndProgramsMappingFranchise',
            'moviesAndProgramsRelated',
            'networks',
            'providers',
            'rules',
            'unmappedMediaItems',
            'users',
            'violations',
        ],
        authReset: ['unmappedMediaItems'],
        paths: ['query.sort', 'query.page', 'query.pageLimit', 'query.exactMatch'],
    },
};

export function applyPreferenceState(preferenceKey, preferenceState, state, whitelistKey) {
    if (preferenceState && includes(get(preferencesConfig, [preferenceKey, 'whitelist'], []), whitelistKey)) {
        map(get(preferencesConfig, [preferenceKey, 'paths']), (path) => {
            const value = get(preferenceState, path);

            if (value) {
                set(state, path, value);
            }
        });
    }

    return cloneDeep(state);
}

export default preferencesConfig;
